import React from "react";
import { Edit, SimpleForm, SelectInput, TextInput, BooleanInput, required } from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { Typography } from "@mui/material";
import { editTitle, minContainer } from "../../../customStyles/ra-custom-styles";
import { languageChoices, positionType } from "utils/options";
import CustomDateInput from "common/components/Fields/CustomDateInput";
import { Grid } from "@mui/material";

const EditVacantPositions = () => {
  return (
    <Edit
      title="Свободна позиция"
      mutationMode="pessimistic"
      sx={editTitle}
    >
      <Typography sx={editTitle}>Редакция на свободна позиция</Typography>
      <SimpleForm sx={minContainer}>
        <Grid container>
          <Grid
            items
            xs={12}
          >
            <SelectInput
              label="Език"
              source="language"
              choices={languageChoices}
              validate={required()}
            />
          </Grid>
          <Grid
            items
            xs={9}
          >
            <TextInput
              label="Заглавие"
              source="title"
              fullWidth
              validate={required()}
              multiline
            />
          </Grid>

          <Grid
            items
            xs={9}
          >
            <TextInput
              label="Населено място"
              source="inhabited_area"
              validate={required()}
              fullWidth
            />
          </Grid>
          <Grid container>
            <Grid
              items
              xs={3}
            >
              <CustomDateInput
                label="Дата на публикуване"
                source="starting_on"
                validate={required()}
              />
            </Grid>
            <Grid
              items
              xs={6}
            >
              <SelectInput
                label="Тип"
                source="type"
                validate={required()}
                choices={positionType}
                fullWidth
              />
            </Grid>
          </Grid>

          <RichTextInput
            label="Съдържание"
            source="content"
            validate={required()}
            fullWidth
            multiline
          />
          <BooleanInput
            label="Скрита"
            source="is_hidden"
          />
        </Grid>
      </SimpleForm>
    </Edit>
  );
};

export default EditVacantPositions;
